module.exports = __webpack_public_path__ + "static/media/news-regina.5a617939.jpg";